import request from './request';

const authService = {
  login: (data) => {
    const { email, password } = data;
  const formData = new FormData();
     formData.append('email', email);
  formData.append('password', password);
    return request.post('auth/login', formData);
  },
  verifyOtp: (data) => request.post('auth/verify-login-otp', data),
};

export default authService;
